
export const dealerRegistration = {
  hero: {
    badge: 'ZOSTAŃ PARTNEREM',
    title: 'Zostań Oficjalnym Dealerem Dutch Fires',
    subtitle: 'Dołącz do naszej ekskluzywnej sieci profesjonalnych partnerów i korzystaj z produktów premium, atrakcyjnych marż i pełnego wsparcia.'
  },
  benefits: {
    title: 'Dlaczego Współpracować z Dutch Fires?',
    benefit1: {
      icon: 'ri-price-tag-3-line',
      title: 'Atrakcyjne Ceny Hurtowe',
      description: 'Skorzystaj z konkurencyjnych cen i wysokich marż dla swojego biznesu'
    },
    benefit2: {
      icon: 'ri-shield-check-line',
      title: 'Ekskluzywne Prawa Terytorialne',
      description: 'Zabezpiecz swoje terytorium i zminimalizuj konkurencję'
    },
    benefit3: {
      icon: 'ri-customer-service-2-line',
      title: 'Pełne Wsparcie',
      description: 'Marketing, szkolenia techniczne i osobista opieka'
    },
    benefit4: {
      icon: 'ri-truck-line',
      title: 'Elastyczna Dostawa',
      description: 'Dropshipping, magazyn lub dostawa projektowa do wyboru'
    }
  },
  requirements: {
    title: 'Wymagania dla Dealerstwa',
    subtitle: 'Aby zostać oficjalnym dealerem Dutch Fires, wymagamy:',
    req1: 'Zarejestrowana firma (KRS lub równoważne)',
    req2: 'Aktywność w sektorze kominków, wnętrz lub budownictwa',
    req3: 'Profesjonalny showroom lub obecność online',
    req4: 'Zaangażowanie w jakość i obsługę klienta'
  },
  form: {
    title: 'Formularz Rejestracyjny',
    subtitle: 'Wypełnij poniższy formularz, a skontaktujemy się z Tobą w ciągu 1-2 dni roboczych.',
    companyName: 'Nazwa Firmy',
    companyNamePlaceholder: 'Nazwa Twojej firmy',
    contactPerson: 'Osoba Kontaktowa',
    contactPersonPlaceholder: 'Imię i nazwisko',
    email: 'Adres Email',
    emailPlaceholder: 'twoj.email@firma.pl',
    phone: 'Numer Telefonu',
    phonePlaceholder: '+48 22 123 4567',
    website: 'Strona Internetowa',
    websitePlaceholder: 'www.twojafirma.pl',
    country: 'Kraj',
    countryPlaceholder: 'Wybierz swój kraj',
    industry: 'Branża',
    industryPlaceholder: 'Wybierz swoją branżę',
    message: 'Wiadomość',
    messagePlaceholder: 'Opowiedz nam o swojej firmie i dlaczego chcesz zostać dealerem Dutch Fires...',
    submit: 'Wyślij Zgłoszenie',
    submitting: 'Wysyłanie...',
    success: 'Dziękujemy za zgłoszenie! Skontaktujemy się z Tobą w ciągu 1-2 dni roboczych.',
    error: 'Coś poszło nie tak. Spróbuj ponownie lub skontaktuj się z nami bezpośrednio.',
    required: 'To pole jest wymagane',
    invalidEmail: 'Nieprawidłowy adres email',
    industries: {
      fireplace: 'Sklep z Kominkami',
      interior: 'Sklep Wnętrzarski',
      construction: 'Firma Budowlana',
      ecommerce: 'E-commerce',
      other: 'Inne'
    }
  },
  process: {
    title: 'Co Dzieje Się Po Twoim Zgłoszeniu?',
    step1: {
      title: 'Weryfikacja',
      description: 'Sprawdzamy Twoje dane firmowe i oceniamy zgłoszenie'
    },
    step2: {
      title: 'Osobisty Kontakt',
      description: 'Jeden z naszych menedżerów kont skontaktuje się z Tobą'
    },
    step3: {
      title: 'Wdrożenie',
      description: 'Dostęp do portalu dealera, szkolenie i materiały marketingowe'
    },
    step4: {
      title: 'Rozpocznij Sprzedaż',
      description: 'Zacznij sprzedawać i korzystaj z naszego wsparcia'
    }
  },
  cta: {
    title: 'Pytania? Skontaktuj Się Bezpośrednio',
    email: 'info@dutchfires.de'
  }
};
